import { createContext, useContext, useEffect, useState } from "react";

export const SUPPORTED_LANGS = [
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
];

const TR = {
  it: {
    "lang.label": "Lingua",
    "nav.reseller": "Rivenditore",
    "dash.hello": "Ciao, {name}",
    "dash.shop_fallback": "Il tuo negozio",
    "dash.subtitle": "Gestisci ordini e materiali marketing in autonomia.",
    "dash.stat_products": "Prodotti a catalogo",
    "dash.stat_orders": "I miei ordini",
    "dash.stat_assets": "Materiali marketing",
    "dash.quick_actions": "Azioni rapide",
    "dash.quick_order_title": "Ordina dal catalogo",
    "dash.quick_order_desc": "Consulta disponibilità e inserisci un riordino.",
    "dash.quick_mk_title": "Marketing Hub",
    "dash.quick_mk_desc": "Scarica foto/video e genera testi social con l'AI.",
    "dash.stats_title": "Le mie statistiche",
    "dash.stats_trend": "Andamento acquisti",
    "dash.stats_trend_desc": "Spesa mensile (IVA escl.) degli ultimi 6 mesi.",
    "dash.stats_top": "I miei prodotti più acquistati",
    "product.detail_title": "Dettaglio prodotto",
    "product.description_label": "Descrizione",
    "product.tech_label": "Caratteristiche tecniche / Composizione",
    "product.colors": "Colori",
    "product.sizes": "Taglie",
    "product.category": "Categoria",
    "product.line_label": "Linea / Collezione",
    "product.code": "Codice articolo",
    "product.gender": "Genere",
    "product.availability": "Disponibilità",
    "product.no_description": "Nessuna descrizione disponibile.",
    "product.zoom": "Ingrandisci",
    "product.auto_translated": "Traduzione automatica",
    "product.translating": "Traduzione in corso…",
    "product.add_to_order": "Aggiungi all'ordine",
    "nav.dashboard": "Dashboard",
    "nav.portal": "Portale B2B",
    "nav.logout": "Esci",
    // Portal shell
    "portal.eyebrow": "Portale Rivenditori B2B",
    "portal.title_fallback": "Portale B2B",
    "portal.subtitle": "Catalogo e disponibilità, ordini in autonomia e materiali marketing.",
    "tier.official": "Rivenditore Ufficiale",
    "tier.potential": "Potenziale Rivenditore · in attesa di abilitazione B2B",
    "tab.catalog": "Catalogo",
    "tab.orders": "I Miei Ordini",
    "tab.marketing": "Marketing Hub",
    "tab.profile": "Profilo",
    "tab.shipping": "Spedizioni",
    "tab.sales_conditions": "Condizioni di vendita",
    "readonly.badge": "Sola lettura",
    "ship.rules_title": "Regole di spedizione",
    "ship.readonly_intro": "Condizioni di spedizione attualmente in vigore, aggiornate dall'azienda.",
    "ship.free_threshold": "Soglia spedizione gratuita (IVA escl.)",
    "ship.flat_cost": "Costo trasporto sotto soglia (IVA escl.)",
    "ship.vat_transport": "IVA su trasporto",
    "ship.free": "gratuita",
    "ship.note": "Ordini ≥ {threshold} → {free} · Ordini < {threshold} → {cost}",
    "sc.title": "Condizioni di vendita — sconti a scaglioni",
    "sc.readonly_intro": "Sconti applicati automaticamente in base all'area di destinazione e all'importo imponibile dell'ordine.",
    "sc.col_range": "Imponibile ordine (IVA escl.)",
    "sc.col_discount": "Sconto",
    "sc.over": "Oltre {from}",
    // Catalog + cart
    "catalog.locked_title": "Account in attesa di abilitazione B2B",
    "catalog.locked_body": "Puoi sfogliare la collezione e scaricare cataloghi e materiali marketing. Prezzi riservati, giacenze e invio ordini saranno disponibili dopo l'approvazione da parte di Above 59 S.r.l. Richiedi l'attivazione dalla sezione Profilo → Contattaci.",
    "catalog.empty": "Nessun prodotto a catalogo. L'amministratore deve caricare l'Excel e le foto.",
    "cart.locked_title": "Ordini non ancora disponibili",
    "cart.locked_body": "Il carrello e l'invio ordini si sbloccano quando il tuo account diventa Rivenditore Ufficiale.",
    "cart.title": "Il tuo ordine",
    "cart.title_note": "(prezzi IVA esclusa)",
    "cart.empty": "Carrello vuoto. Aggiungi prodotti dal catalogo.",
    "cart.size": "Taglia",
    "cart.ship_address": "Indirizzo di spedizione",
    "cart.choose_address": "Scegli indirizzo",
    "cart.default_suffix": "(predefinito)",
    "cart.manage_addr_note": "Gestisci gli indirizzi nella scheda Profilo.",
    "cart.subtotal": "Imponibile (senza IVA)",
    "cart.list_subtotal": "Subtotale (listino)",
    "cart.volume_discount": "Sconto volume",
    "cart.shipping": "Trasporto",
    "cart.free_shipping": "Spedizione Gratuita",
    "cart.shipping_note_below": "Spedizione gratuita per ordini imponibili ≥ {threshold} ({zone}). Aggiungi {missing} per ottenerla.",
    "cart.shipping_note_free": "Hai superato la soglia di {threshold}: spedizione gratuita ({zone}).",
    "cart.vat": "IVA",
    "cart.vat_exempt": "Non imponibile",
    "cart.total_incl": "Totale (IVA inclusa)",
    "cart.total_exempt": "Totale (IVA esente)",
    "cart.submit": "Invia ordine",
    "toast.select_size": "Seleziona una taglia",
    "toast.added": "{item} aggiunto",
    // Product card
    "product.locked_note": "Prezzi B2B e disponibilità riservati ai Rivenditori Ufficiali.",
    "product.list_public": "Listino pubblico",
    "product.vat_incl": "IVA incl.",
    "product.list_excl": "Listino (IVA escl.)",
    "product.reseller_discount": "Sconto rivenditore",
    "product.your_price": "Tuo prezzo (IVA escl.)",
    "product.pcs_total": "{n} pz totali",
    "product.only_pcs": "Solo {n} pz",
    "product.pcs_avail": "{n} disp.",
    "product.size_ph": "Taglia",
    "product.size_unica": "Unica",
    "product.sold_out": "esaurita",
    "product.add": "Aggiungi",
    // Orders
    "orders.locked_title": "Ordini non ancora disponibili",
    "orders.locked_body": "Potrai inviare ordini B2B una volta che il tuo account sarà abilitato come Rivenditore Ufficiale. Richiedi l'attivazione da Profilo → Contattaci.",
    "orders.period": "Periodo",
    "orders.from": "Da",
    "orders.to": "A",
    "orders.apply": "Applica",
    "orders.last12": "Ultimi 12 mesi",
    "orders.count": "{n} ordini",
    "orders.empty": "Nessun ordine nel periodo selezionato.",
    "orders.col_date": "Data",
    "orders.col_id": "ID Ordine",
    "orders.col_recipient": "Destinatario / Città",
    "orders.col_status": "Stato",
    "orders.col_total": "Totale",
    "orders.detail": "Dettaglio",
    "toast.orders_load_error": "Impossibile caricare gli ordini",
    "toast.order_detail_error": "Impossibile caricare il dettaglio",
    // Marketing
    "mk.assets_title": "Materiali scaricabili",
    "mk.all_categories": "Tutte le categorie",
    "mk.empty_category": "Nessun materiale in questa categoria.",
    "mk.copy_text": "Copia testo",
    "mk.copied": "Copiato",
    "mk.download": "Scarica",
    "mk.ai_title": "Assistente AI · Testi social",
    "mk.topic": "Tema del post",
    "mk.topic_ph": "Es. Arrivata la nuova collezione invernale",
    "mk.product_opt": "Prodotto (opz.)",
    "mk.none": "Nessuno",
    "mk.platform": "Piattaforma",
    "mk.tone": "Tono",
    "mk.tone_energico": "Energico",
    "mk.tone_elegante": "Elegante",
    "mk.tone_tecnico": "Tecnico",
    "mk.tone_amichevole": "Amichevole",
    "mk.generate": "Genera testo per post",
    "mk.generating": "Generazione…",
    "toast.enter_topic": "Inserisci un tema per il post",
    // Profile
    "pf.fiscal_title": "Anagrafica fiscale",
    "pf.fiscal_note": "Dati ufficiali gestiti da Brema. Per modifiche contatta il tuo referente commerciale.",
    "pf.company": "Ragione sociale",
    "pf.vat": "Partita IVA",
    "pf.billing": "Indirizzo di fatturazione",
    "pf.account_email": "Email account",
    "pf.above59_note": "I dati fiscali e l'abilitazione agli ordini vengono verificati e approvati direttamente da Above 59 S.r.l. (società proprietaria del marchio Brema). Se desideri diventare rivenditore ufficiale, verificare la copertura di zona o attivare il tuo conto B2B, clicca qui sotto.",
    "pf.contact_us": "Contattaci",
    "pf.write_company": "Scrivi all'azienda",
    "pf.subject": "Oggetto",
    "pf.subject_ph": "Es. Domanda amministrativa, fattura, resi, proposta…",
    "pf.contact_title": "Contatta il reparto commerciale",
    "pf.contact_desc": "Scrivi la tua richiesta ad Above 59 S.r.l. (proprietaria del marchio Brema). Ti risponderemo all'email di contatto del tuo profilo.",
    "pf.message": "Messaggio",
    "pf.contact_ph": "Es. Vorrei attivare il mio conto B2B / verificare l'esclusiva di zona per la mia città / aggiornare i miei dati fiscali…",
    "pf.send_request": "Invia richiesta",
    "pf.contacts": "Recapiti",
    "pf.phone": "Telefono",
    "pf.contact_email": "Email di contatto",
    "pf.save_contacts": "Salva recapiti",
    "pf.ship_addresses": "Indirizzi di spedizione",
    "pf.new_address": "Nuovo indirizzo",
    "pf.no_addresses": "Nessun indirizzo di spedizione. Aggiungine uno.",
    "pf.default": "Predefinito",
    "pf.set_default": "Predefinito",
    "pf.edit_address": "Modifica indirizzo",
    "pf.address_desc": "Indirizzo di destinazione merce per i tuoi ordini.",
    "pf.save_address": "Salva indirizzo",
    "common.cancel": "Annulla",
    "common.edit": "Modifica",
    "toast.write_message": "Scrivi un messaggio",
    "toast.contact_sent": "Messaggio inviato al reparto commerciale. Ti risponderemo presto.",
    "toast.contact_failed": "Invio fallito",
    "toast.profile_saved": "Profilo aggiornato",
    "toast.save_failed": "Salvataggio fallito",
    "toast.addr_min": "Inserisci almeno destinatario o città",
    "toast.del_addr_confirm": "Eliminare questo indirizzo?",
    "toast.order_sent": "Ordine inviato con successo",
    "toast.order_confirm_email": "Conferma d'ordine inviata via email",
    // Login / Register
    "login.hero_eyebrow": "Piattaforma AI-Native",
    "login.hero_title": "Distribuzione e marketing dell'abbigliamento tecnico, guidati dall'AI.",
    "login.hero_sub": "Sales agent autonomo, portale rivenditori B2B e ricerca ambassador in un'unica plancia di comando.",
    "login.tab_login": "Accedi",
    "login.tab_register": "Registra negozio",
    "login.welcome_back": "Bentornato",
    "login.login_sub": "Accedi alla tua area riservata.",
    "login.email": "Email",
    "login.password": "Password",
    "login.signin": "Accedi",
    "login.demo": "Account demo",
    "login.demo_admin": "Brand / Admin",
    "login.demo_reseller": "Rivenditore",
    "login.register_title": "Registra il tuo negozio",
    "login.register_sub": "Crea un account rivenditore B2B.",
    "login.ref": "Referente",
    "login.city": "Città",
    "login.shop": "Ragione Sociale / Nome Negozio",
    "login.vat": "Partita IVA / VIES",
    "login.address": "Indirizzo (Via e numero)",
    "login.zip": "CAP",
    "login.province": "Provincia",
    "login.country": "Nazione",
    "login.phone": "Telefono di contatto",
    "login.website": "Sito web o pagina social (facoltativo)",
    "login.notes": "Note aggiuntive (facoltativo)",
    "login.forgot": "Password dimenticata?",
    "login.forgot_title": "Reimposta la password",
    "login.forgot_desc": "Inserisci la tua email: se è registrata riceverai un link per reimpostare la password.",
    "login.forgot_send": "Invia link di reset",
    "login.forgot_sent": "Se l'email è registrata, riceverai un link per reimpostare la password.",
    "login.password_ph": "min. 6 caratteri",
    "login.create": "Crea account",
    "toast.welcome": "Benvenuto, {name}",
    "toast.account_created": "Account rivenditore creato",
  },

  en: {
    "lang.label": "Language",
    "nav.reseller": "Reseller",
    "dash.hello": "Hi, {name}",
    "dash.shop_fallback": "Your store",
    "dash.subtitle": "Manage orders and marketing materials on your own.",
    "dash.stat_products": "Catalog products",
    "dash.stat_orders": "My orders",
    "dash.stat_assets": "Marketing materials",
    "dash.quick_actions": "Quick actions",
    "dash.quick_order_title": "Order from catalog",
    "dash.quick_order_desc": "Check availability and place a reorder.",
    "dash.quick_mk_title": "Marketing Hub",
    "dash.quick_mk_desc": "Download photos/videos and generate social copy with AI.",
    "dash.stats_title": "My statistics",
    "dash.stats_trend": "Purchase trend",
    "dash.stats_trend_desc": "Monthly spend (excl. VAT) over the last 6 months.",
    "dash.stats_top": "My most purchased products",
    "product.detail_title": "Product details",
    "product.description_label": "Description",
    "product.tech_label": "Technical specs / Composition",
    "product.colors": "Colors",
    "product.sizes": "Sizes",
    "product.category": "Category",
    "product.line_label": "Line / Collection",
    "product.code": "Article code",
    "product.gender": "Gender",
    "product.availability": "Availability",
    "product.no_description": "No description available.",
    "product.zoom": "Zoom",
    "product.auto_translated": "Auto-translated",
    "product.translating": "Translating…",
    "product.add_to_order": "Add to order",
    "nav.dashboard": "Dashboard",
    "nav.portal": "B2B Portal",
    "nav.logout": "Log out",
    "portal.eyebrow": "B2B Reseller Portal",
    "portal.title_fallback": "B2B Portal",
    "portal.subtitle": "Catalog and availability, self-service orders and marketing materials.",
    "tier.official": "Official Reseller",
    "tier.potential": "Prospective Reseller · awaiting B2B activation",
    "tab.catalog": "Catalog",
    "tab.orders": "My Orders",
    "tab.marketing": "Marketing Hub",
    "tab.profile": "Profile",
    "tab.shipping": "Shipping",
    "tab.sales_conditions": "Sales conditions",
    "readonly.badge": "Read-only",
    "ship.rules_title": "Shipping rules",
    "ship.readonly_intro": "Shipping terms currently in force, kept up to date by the company.",
    "ship.free_threshold": "Free shipping threshold (excl. VAT)",
    "ship.flat_cost": "Shipping cost below threshold (excl. VAT)",
    "ship.vat_transport": "VAT on shipping",
    "ship.free": "free",
    "ship.note": "Orders ≥ {threshold} → {free} · Orders < {threshold} → {cost}",
    "sc.title": "Sales conditions — volume discount tiers",
    "sc.readonly_intro": "Discounts applied automatically based on destination area and the order's taxable amount.",
    "sc.col_range": "Order taxable amount (excl. VAT)",
    "sc.col_discount": "Discount",
    "sc.over": "Over {from}",
    "catalog.locked_title": "Account awaiting B2B activation",
    "catalog.locked_body": "You can browse the collection and download catalogs and marketing materials. Reserved prices, stock and order submission will be available after approval by Above 59 S.r.l. Request activation from the Profile → Contact us section.",
    "catalog.empty": "No products in the catalog. The administrator needs to upload the Excel and photos.",
    "cart.locked_title": "Orders not yet available",
    "cart.locked_body": "The cart and order submission unlock once your account becomes an Official Reseller.",
    "cart.title": "Your order",
    "cart.title_note": "(prices excl. VAT)",
    "cart.empty": "Empty cart. Add products from the catalog.",
    "cart.size": "Size",
    "cart.ship_address": "Shipping address",
    "cart.choose_address": "Choose address",
    "cart.default_suffix": "(default)",
    "cart.manage_addr_note": "Manage addresses in the Profile tab.",
    "cart.subtotal": "Subtotal (excl. VAT)",
    "cart.list_subtotal": "List subtotal",
    "cart.volume_discount": "Volume discount",
    "cart.shipping": "Shipping",
    "cart.free_shipping": "Free Shipping",
    "cart.shipping_note_below": "Free shipping for net orders ≥ {threshold} ({zone}). Add {missing} to qualify.",
    "cart.shipping_note_free": "You passed the {threshold} threshold: free shipping ({zone}).",
    "cart.vat": "VAT",
    "cart.vat_exempt": "Not taxable",
    "cart.total_incl": "Total (VAT incl.)",
    "cart.total_exempt": "Total (VAT exempt)",
    "cart.submit": "Place order",
    "toast.select_size": "Select a size",
    "toast.added": "{item} added",
    "product.locked_note": "B2B prices and availability reserved for Official Resellers.",
    "product.list_public": "Public price",
    "product.vat_incl": "VAT incl.",
    "product.list_excl": "List (excl. VAT)",
    "product.reseller_discount": "Reseller discount",
    "product.your_price": "Your price (excl. VAT)",
    "product.pcs_total": "{n} pcs total",
    "product.only_pcs": "Only {n} pcs",
    "product.pcs_avail": "{n} avail.",
    "product.size_ph": "Size",
    "product.size_unica": "One size",
    "product.sold_out": "sold out",
    "product.add": "Add",
    "orders.locked_title": "Orders not yet available",
    "orders.locked_body": "You will be able to submit B2B orders once your account is activated as an Official Reseller. Request activation from Profile → Contact us.",
    "orders.period": "Period",
    "orders.from": "From",
    "orders.to": "To",
    "orders.apply": "Apply",
    "orders.last12": "Last 12 months",
    "orders.count": "{n} orders",
    "orders.empty": "No orders in the selected period.",
    "orders.col_date": "Date",
    "orders.col_id": "Order ID",
    "orders.col_recipient": "Recipient / City",
    "orders.col_status": "Status",
    "orders.col_total": "Total",
    "orders.detail": "Details",
    "toast.orders_load_error": "Unable to load orders",
    "toast.order_detail_error": "Unable to load the details",
    "mk.assets_title": "Downloadable materials",
    "mk.all_categories": "All categories",
    "mk.empty_category": "No material in this category.",
    "mk.copy_text": "Copy text",
    "mk.copied": "Copied",
    "mk.download": "Download",
    "mk.ai_title": "AI Assistant · Social copy",
    "mk.topic": "Post topic",
    "mk.topic_ph": "E.g. The new winter collection has arrived",
    "mk.product_opt": "Product (opt.)",
    "mk.none": "None",
    "mk.platform": "Platform",
    "mk.tone": "Tone",
    "mk.tone_energico": "Energetic",
    "mk.tone_elegante": "Elegant",
    "mk.tone_tecnico": "Technical",
    "mk.tone_amichevole": "Friendly",
    "mk.generate": "Generate post copy",
    "mk.generating": "Generating…",
    "toast.enter_topic": "Enter a topic for the post",
    "pf.fiscal_title": "Tax details",
    "pf.fiscal_note": "Official data managed by Brema. For changes, contact your sales representative.",
    "pf.company": "Company name",
    "pf.vat": "VAT number",
    "pf.billing": "Billing address",
    "pf.account_email": "Account email",
    "pf.above59_note": "Tax data and order activation are verified and approved directly by Above 59 S.r.l. (owner of the Brema brand). If you wish to become an official reseller, check area coverage or activate your B2B account, click below.",
    "pf.contact_us": "Contact us",
    "pf.write_company": "Write to the company",
    "pf.subject": "Subject",
    "pf.subject_ph": "E.g. Admin question, invoice, returns, proposal…",
    "pf.contact_title": "Contact the sales department",
    "pf.contact_desc": "Write your request to Above 59 S.r.l. (owner of the Brema brand). We will reply to your profile's contact email.",
    "pf.message": "Message",
    "pf.contact_ph": "E.g. I would like to activate my B2B account / check area exclusivity for my city / update my tax details…",
    "pf.send_request": "Send request",
    "pf.contacts": "Contact details",
    "pf.phone": "Phone",
    "pf.contact_email": "Contact email",
    "pf.save_contacts": "Save contacts",
    "pf.ship_addresses": "Shipping addresses",
    "pf.new_address": "New address",
    "pf.no_addresses": "No shipping address. Add one.",
    "pf.default": "Default",
    "pf.set_default": "Default",
    "pf.edit_address": "Edit address",
    "pf.address_desc": "Goods destination address for your orders.",
    "pf.save_address": "Save address",
    "common.cancel": "Cancel",
    "common.edit": "Edit",
    "toast.write_message": "Write a message",
    "toast.contact_sent": "Message sent to the sales department. We will reply soon.",
    "toast.contact_failed": "Send failed",
    "toast.profile_saved": "Profile updated",
    "toast.save_failed": "Save failed",
    "toast.addr_min": "Enter at least a recipient or a city",
    "toast.del_addr_confirm": "Delete this address?",
    "toast.order_sent": "Order sent successfully",
    "toast.order_confirm_email": "Order confirmation sent by email",
    "login.hero_eyebrow": "AI-Native Platform",
    "login.hero_title": "AI-driven distribution and marketing of technical apparel.",
    "login.hero_sub": "Autonomous sales agent, B2B reseller portal and ambassador search in a single command deck.",
    "login.tab_login": "Sign in",
    "login.tab_register": "Register store",
    "login.welcome_back": "Welcome back",
    "login.login_sub": "Access your reserved area.",
    "login.email": "Email",
    "login.password": "Password",
    "login.signin": "Sign in",
    "login.demo": "Demo accounts",
    "login.demo_admin": "Brand / Admin",
    "login.demo_reseller": "Reseller",
    "login.register_title": "Register your store",
    "login.register_sub": "Create a B2B reseller account.",
    "login.ref": "Contact person",
    "login.city": "City",
    "login.shop": "Company name / Store name",
    "login.vat": "VAT number / VIES",
    "login.address": "Address (street and number)",
    "login.zip": "ZIP / Postal code",
    "login.province": "Province",
    "login.country": "Country",
    "login.phone": "Contact phone",
    "login.website": "Website or social page (optional)",
    "login.notes": "Additional notes (optional)",
    "login.forgot": "Forgot password?",
    "login.forgot_title": "Reset your password",
    "login.forgot_desc": "Enter your email: if it's registered you'll receive a link to reset your password.",
    "login.forgot_send": "Send reset link",
    "login.forgot_sent": "If the email is registered, you'll receive a link to reset your password.",
    "login.password_ph": "min. 6 characters",
    "login.create": "Create account",
    "toast.welcome": "Welcome, {name}",
    "toast.account_created": "Reseller account created",
  },

  fr: {
    "lang.label": "Langue",
    "nav.reseller": "Revendeur",
    "dash.hello": "Bonjour, {name}",
    "dash.shop_fallback": "Votre magasin",
    "dash.subtitle": "Gérez vos commandes et supports marketing en autonomie.",
    "dash.stat_products": "Produits au catalogue",
    "dash.stat_orders": "Mes commandes",
    "dash.stat_assets": "Supports marketing",
    "dash.quick_actions": "Actions rapides",
    "dash.quick_order_title": "Commander depuis le catalogue",
    "dash.quick_order_desc": "Consultez la disponibilité et passez une commande.",
    "dash.quick_mk_title": "Marketing Hub",
    "dash.quick_mk_desc": "Téléchargez photos/vidéos et générez des textes sociaux avec l'IA.",
    "dash.stats_title": "Mes statistiques",
    "dash.stats_trend": "Évolution des achats",
    "dash.stats_trend_desc": "Dépense mensuelle (HT) sur les 6 derniers mois.",
    "dash.stats_top": "Mes produits les plus achetés",
    "product.detail_title": "Détail produit",
    "product.description_label": "Description",
    "product.tech_label": "Caractéristiques techniques / Composition",
    "product.colors": "Couleurs",
    "product.sizes": "Tailles",
    "product.category": "Catégorie",
    "product.line_label": "Ligne / Collection",
    "product.code": "Code article",
    "product.gender": "Genre",
    "product.availability": "Disponibilité",
    "product.no_description": "Aucune description disponible.",
    "product.zoom": "Agrandir",
    "product.auto_translated": "Traduction automatique",
    "product.translating": "Traduction en cours…",
    "product.add_to_order": "Ajouter à la commande",
    "nav.dashboard": "Tableau de bord",
    "nav.portal": "Portail B2B",
    "nav.logout": "Se déconnecter",
    "portal.eyebrow": "Portail Revendeurs B2B",
    "portal.title_fallback": "Portail B2B",
    "portal.subtitle": "Catalogue et disponibilités, commandes en autonomie et supports marketing.",
    "tier.official": "Revendeur Officiel",
    "tier.potential": "Revendeur Potentiel · en attente d'activation B2B",
    "tab.catalog": "Catalogue",
    "tab.orders": "Mes Commandes",
    "tab.marketing": "Espace Marketing",
    "tab.profile": "Profil",
    "tab.shipping": "Livraisons",
    "tab.sales_conditions": "Conditions de vente",
    "readonly.badge": "Lecture seule",
    "ship.rules_title": "Règles de livraison",
    "ship.readonly_intro": "Conditions de livraison actuellement en vigueur, mises à jour par l'entreprise.",
    "ship.free_threshold": "Seuil de livraison gratuite (HT)",
    "ship.flat_cost": "Frais de port sous le seuil (HT)",
    "ship.vat_transport": "TVA sur le transport",
    "ship.free": "gratuite",
    "ship.note": "Commandes ≥ {threshold} → {free} · Commandes < {threshold} → {cost}",
    "sc.title": "Conditions de vente — remises par volume",
    "sc.readonly_intro": "Remises appliquées automatiquement selon la zone de destination et le montant HT de la commande.",
    "sc.col_range": "Montant HT de la commande",
    "sc.col_discount": "Remise",
    "sc.over": "Au-delà de {from}",
    "catalog.locked_title": "Compte en attente d'activation B2B",
    "catalog.locked_body": "Vous pouvez parcourir la collection et télécharger catalogues et supports marketing. Les prix réservés, les stocks et l'envoi des commandes seront disponibles après approbation par Above 59 S.r.l. Demandez l'activation depuis la section Profil → Contactez-nous.",
    "catalog.empty": "Aucun produit au catalogue. L'administrateur doit importer l'Excel et les photos.",
    "cart.locked_title": "Commandes pas encore disponibles",
    "cart.locked_body": "Le panier et l'envoi des commandes se débloquent lorsque votre compte devient Revendeur Officiel.",
    "cart.title": "Votre commande",
    "cart.title_note": "(prix HT)",
    "cart.empty": "Panier vide. Ajoutez des produits depuis le catalogue.",
    "cart.size": "Taille",
    "cart.ship_address": "Adresse de livraison",
    "cart.choose_address": "Choisir une adresse",
    "cart.default_suffix": "(par défaut)",
    "cart.manage_addr_note": "Gérez les adresses dans l'onglet Profil.",
    "cart.subtotal": "Montant HT",
    "cart.list_subtotal": "Sous-total (tarif)",
    "cart.volume_discount": "Remise volume",
    "cart.shipping": "Transport",
    "cart.free_shipping": "Livraison Gratuite",
    "cart.shipping_note_below": "Livraison gratuite pour les commandes HT ≥ {threshold} ({zone}). Ajoutez {missing} pour en bénéficier.",
    "cart.shipping_note_free": "Vous avez dépassé le seuil de {threshold} : livraison gratuite ({zone}).",
    "cart.vat": "TVA",
    "cart.vat_exempt": "Non imposable",
    "cart.total_incl": "Total (TTC)",
    "cart.total_exempt": "Total (TVA exonérée)",
    "cart.submit": "Envoyer la commande",
    "toast.select_size": "Sélectionnez une taille",
    "toast.added": "{item} ajouté",
    "product.locked_note": "Prix B2B et disponibilités réservés aux Revendeurs Officiels.",
    "product.list_public": "Prix public",
    "product.vat_incl": "TTC",
    "product.list_excl": "Tarif (HT)",
    "product.reseller_discount": "Remise revendeur",
    "product.your_price": "Votre prix (HT)",
    "product.pcs_total": "{n} pcs au total",
    "product.only_pcs": "Plus que {n} pcs",
    "product.pcs_avail": "{n} disp.",
    "product.size_ph": "Taille",
    "product.size_unica": "Unique",
    "product.sold_out": "épuisée",
    "product.add": "Ajouter",
    "orders.locked_title": "Commandes pas encore disponibles",
    "orders.locked_body": "Vous pourrez envoyer des commandes B2B une fois votre compte activé en tant que Revendeur Officiel. Demandez l'activation depuis Profil → Contactez-nous.",
    "orders.period": "Période",
    "orders.from": "Du",
    "orders.to": "Au",
    "orders.apply": "Appliquer",
    "orders.last12": "12 derniers mois",
    "orders.count": "{n} commandes",
    "orders.empty": "Aucune commande sur la période sélectionnée.",
    "orders.col_date": "Date",
    "orders.col_id": "N° Commande",
    "orders.col_recipient": "Destinataire / Ville",
    "orders.col_status": "Statut",
    "orders.col_total": "Total",
    "orders.detail": "Détail",
    "toast.orders_load_error": "Impossible de charger les commandes",
    "toast.order_detail_error": "Impossible de charger le détail",
    "mk.assets_title": "Supports téléchargeables",
    "mk.all_categories": "Toutes les catégories",
    "mk.empty_category": "Aucun support dans cette catégorie.",
    "mk.copy_text": "Copier le texte",
    "mk.copied": "Copié",
    "mk.download": "Télécharger",
    "mk.ai_title": "Assistant IA · Textes réseaux sociaux",
    "mk.topic": "Thème du post",
    "mk.topic_ph": "Ex. La nouvelle collection hiver est arrivée",
    "mk.product_opt": "Produit (opt.)",
    "mk.none": "Aucun",
    "mk.platform": "Plateforme",
    "mk.tone": "Ton",
    "mk.tone_energico": "Énergique",
    "mk.tone_elegante": "Élégant",
    "mk.tone_tecnico": "Technique",
    "mk.tone_amichevole": "Amical",
    "mk.generate": "Générer le texte du post",
    "mk.generating": "Génération…",
    "toast.enter_topic": "Saisissez un thème pour le post",
    "pf.fiscal_title": "Données fiscales",
    "pf.fiscal_note": "Données officielles gérées par Brema. Pour toute modification, contactez votre référent commercial.",
    "pf.company": "Raison sociale",
    "pf.vat": "N° de TVA",
    "pf.billing": "Adresse de facturation",
    "pf.account_email": "E-mail du compte",
    "pf.above59_note": "Les données fiscales et l'activation des commandes sont vérifiées et approuvées directement par Above 59 S.r.l. (propriétaire de la marque Brema). Si vous souhaitez devenir revendeur officiel, vérifier la couverture de zone ou activer votre compte B2B, cliquez ci-dessous.",
    "pf.contact_us": "Contactez-nous",
    "pf.write_company": "Écrire à l'entreprise",
    "pf.subject": "Objet",
    "pf.subject_ph": "Ex. Question administrative, facture, retours, proposition…",
    "pf.contact_title": "Contactez le service commercial",
    "pf.contact_desc": "Écrivez votre demande à Above 59 S.r.l. (propriétaire de la marque Brema). Nous répondrons à l'e-mail de contact de votre profil.",
    "pf.message": "Message",
    "pf.contact_ph": "Ex. Je souhaite activer mon compte B2B / vérifier l'exclusivité de zone pour ma ville / mettre à jour mes données fiscales…",
    "pf.send_request": "Envoyer la demande",
    "pf.contacts": "Coordonnées",
    "pf.phone": "Téléphone",
    "pf.contact_email": "E-mail de contact",
    "pf.save_contacts": "Enregistrer",
    "pf.ship_addresses": "Adresses de livraison",
    "pf.new_address": "Nouvelle adresse",
    "pf.no_addresses": "Aucune adresse de livraison. Ajoutez-en une.",
    "pf.default": "Par défaut",
    "pf.set_default": "Par défaut",
    "pf.edit_address": "Modifier l'adresse",
    "pf.address_desc": "Adresse de destination des marchandises pour vos commandes.",
    "pf.save_address": "Enregistrer l'adresse",
    "common.cancel": "Annuler",
    "common.edit": "Modifier",
    "toast.write_message": "Écrivez un message",
    "toast.contact_sent": "Message envoyé au service commercial. Nous vous répondrons bientôt.",
    "toast.contact_failed": "Échec de l'envoi",
    "toast.profile_saved": "Profil mis à jour",
    "toast.save_failed": "Échec de l'enregistrement",
    "toast.addr_min": "Saisissez au moins un destinataire ou une ville",
    "toast.del_addr_confirm": "Supprimer cette adresse ?",
    "toast.order_sent": "Commande envoyée avec succès",
    "toast.order_confirm_email": "Confirmation de commande envoyée par e-mail",
    "login.hero_eyebrow": "Plateforme AI-Native",
    "login.hero_title": "Distribution et marketing de vêtements techniques, pilotés par l'IA.",
    "login.hero_sub": "Sales agent autonome, portail revendeurs B2B et recherche d'ambassadeurs dans un seul poste de commande.",
    "login.tab_login": "Se connecter",
    "login.tab_register": "Enregistrer un magasin",
    "login.welcome_back": "Bon retour",
    "login.login_sub": "Accédez à votre espace réservé.",
    "login.email": "E-mail",
    "login.password": "Mot de passe",
    "login.signin": "Se connecter",
    "login.demo": "Comptes démo",
    "login.demo_admin": "Marque / Admin",
    "login.demo_reseller": "Revendeur",
    "login.register_title": "Enregistrez votre magasin",
    "login.register_sub": "Créez un compte revendeur B2B.",
    "login.ref": "Contact",
    "login.city": "Ville",
    "login.shop": "Raison sociale / Nom du magasin",
    "login.vat": "Numéro de TVA / VIES",
    "login.address": "Adresse (rue et numéro)",
    "login.zip": "Code postal",
    "login.province": "Province",
    "login.country": "Pays",
    "login.phone": "Téléphone de contact",
    "login.website": "Site web ou page sociale (facultatif)",
    "login.notes": "Notes complémentaires (facultatif)",
    "login.forgot": "Mot de passe oublié ?",
    "login.forgot_title": "Réinitialiser le mot de passe",
    "login.forgot_desc": "Saisissez votre e-mail : s'il est enregistré, vous recevrez un lien de réinitialisation.",
    "login.forgot_send": "Envoyer le lien",
    "login.forgot_sent": "Si l'e-mail est enregistré, vous recevrez un lien de réinitialisation.",
    "login.password_ph": "min. 6 caractères",
    "login.create": "Créer le compte",
    "toast.welcome": "Bienvenue, {name}",
    "toast.account_created": "Compte revendeur créé",
  },

  de: {
    "lang.label": "Sprache",
    "nav.reseller": "Händler",
    "dash.hello": "Hallo, {name}",
    "dash.shop_fallback": "Ihr Geschäft",
    "dash.subtitle": "Verwalten Sie Bestellungen und Marketingmaterialien selbstständig.",
    "dash.stat_products": "Katalogprodukte",
    "dash.stat_orders": "Meine Bestellungen",
    "dash.stat_assets": "Marketingmaterialien",
    "dash.quick_actions": "Schnellaktionen",
    "dash.quick_order_title": "Aus dem Katalog bestellen",
    "dash.quick_order_desc": "Verfügbarkeit prüfen und nachbestellen.",
    "dash.quick_mk_title": "Marketing Hub",
    "dash.quick_mk_desc": "Fotos/Videos herunterladen und Social-Texte mit KI erstellen.",
    "dash.stats_title": "Meine Statistiken",
    "dash.stats_trend": "Kaufentwicklung",
    "dash.stats_trend_desc": "Monatliche Ausgaben (exkl. MwSt.) der letzten 6 Monate.",
    "dash.stats_top": "Meine meistgekauften Produkte",
    "product.detail_title": "Produktdetails",
    "product.description_label": "Beschreibung",
    "product.tech_label": "Technische Merkmale / Zusammensetzung",
    "product.colors": "Farben",
    "product.sizes": "Größen",
    "product.category": "Kategorie",
    "product.line_label": "Linie / Kollektion",
    "product.code": "Artikelnummer",
    "product.gender": "Geschlecht",
    "product.availability": "Verfügbarkeit",
    "product.no_description": "Keine Beschreibung verfügbar.",
    "product.zoom": "Vergrößern",
    "product.auto_translated": "Automatisch übersetzt",
    "product.translating": "Übersetzung läuft…",
    "product.add_to_order": "Zur Bestellung hinzufügen",
    "nav.dashboard": "Dashboard",
    "nav.portal": "B2B-Portal",
    "nav.logout": "Abmelden",
    "portal.eyebrow": "B2B-Händlerportal",
    "portal.title_fallback": "B2B-Portal",
    "portal.subtitle": "Katalog und Verfügbarkeit, Bestellungen in Eigenregie und Marketingmaterialien.",
    "tier.official": "Offizieller Händler",
    "tier.potential": "Potenzieller Händler · wartet auf B2B-Freischaltung",
    "tab.catalog": "Katalog",
    "tab.orders": "Meine Bestellungen",
    "tab.marketing": "Marketing-Hub",
    "tab.profile": "Profil",
    "tab.shipping": "Versand",
    "tab.sales_conditions": "Verkaufsbedingungen",
    "readonly.badge": "Nur Lesen",
    "ship.rules_title": "Versandregeln",
    "ship.readonly_intro": "Aktuell gültige Versandbedingungen, vom Unternehmen aktualisiert.",
    "ship.free_threshold": "Schwelle für kostenlosen Versand (exkl. MwSt.)",
    "ship.flat_cost": "Versandkosten unter der Schwelle (exkl. MwSt.)",
    "ship.vat_transport": "MwSt. auf Versand",
    "ship.free": "kostenlos",
    "ship.note": "Bestellungen ≥ {threshold} → {free} · Bestellungen < {threshold} → {cost}",
    "sc.title": "Verkaufsbedingungen — Mengenrabatte",
    "sc.readonly_intro": "Rabatte werden automatisch nach Zielgebiet und Nettobetrag der Bestellung angewendet.",
    "sc.col_range": "Nettobetrag der Bestellung (exkl. MwSt.)",
    "sc.col_discount": "Rabatt",
    "sc.over": "Über {from}",
    "catalog.locked_title": "Konto wartet auf B2B-Freischaltung",
    "catalog.locked_body": "Sie können die Kollektion durchsuchen und Kataloge sowie Marketingmaterialien herunterladen. Reservierte Preise, Bestände und Bestellversand sind nach Freigabe durch Above 59 S.r.l. verfügbar. Fordern Sie die Freischaltung im Bereich Profil → Kontakt an.",
    "catalog.empty": "Keine Produkte im Katalog. Der Administrator muss die Excel-Datei und die Fotos hochladen.",
    "cart.locked_title": "Bestellungen noch nicht verfügbar",
    "cart.locked_body": "Warenkorb und Bestellversand werden freigeschaltet, sobald Ihr Konto zum Offiziellen Händler wird.",
    "cart.title": "Ihre Bestellung",
    "cart.title_note": "(Preise exkl. MwSt.)",
    "cart.empty": "Leerer Warenkorb. Fügen Sie Produkte aus dem Katalog hinzu.",
    "cart.size": "Größe",
    "cart.ship_address": "Lieferadresse",
    "cart.choose_address": "Adresse wählen",
    "cart.default_suffix": "(Standard)",
    "cart.manage_addr_note": "Adressen im Reiter Profil verwalten.",
    "cart.subtotal": "Nettobetrag (exkl. MwSt.)",
    "cart.list_subtotal": "Zwischensumme (Liste)",
    "cart.volume_discount": "Mengenrabatt",
    "cart.shipping": "Versand",
    "cart.free_shipping": "Kostenloser Versand",
    "cart.shipping_note_below": "Kostenloser Versand für Nettobestellungen ≥ {threshold} ({zone}). Fügen Sie {missing} hinzu.",
    "cart.shipping_note_free": "Sie haben die Schwelle von {threshold} überschritten: kostenloser Versand ({zone}).",
    "cart.vat": "MwSt.",
    "cart.vat_exempt": "Nicht steuerpflichtig",
    "cart.total_incl": "Gesamt (inkl. MwSt.)",
    "cart.total_exempt": "Gesamt (MwSt.-befreit)",
    "cart.submit": "Bestellung senden",
    "toast.select_size": "Wählen Sie eine Größe",
    "toast.added": "{item} hinzugefügt",
    "product.locked_note": "B2B-Preise und Verfügbarkeit nur für Offizielle Händler.",
    "product.list_public": "Öffentlicher Preis",
    "product.vat_incl": "inkl. MwSt.",
    "product.list_excl": "Liste (exkl. MwSt.)",
    "product.reseller_discount": "Händlerrabatt",
    "product.your_price": "Ihr Preis (exkl. MwSt.)",
    "product.pcs_total": "{n} Stk. gesamt",
    "product.only_pcs": "Nur {n} Stk.",
    "product.pcs_avail": "{n} verf.",
    "product.size_ph": "Größe",
    "product.size_unica": "Einheitsgröße",
    "product.sold_out": "ausverkauft",
    "product.add": "Hinzufügen",
    "orders.locked_title": "Bestellungen noch nicht verfügbar",
    "orders.locked_body": "Sie können B2B-Bestellungen senden, sobald Ihr Konto als Offizieller Händler freigeschaltet ist. Freischaltung über Profil → Kontakt anfordern.",
    "orders.period": "Zeitraum",
    "orders.from": "Von",
    "orders.to": "Bis",
    "orders.apply": "Anwenden",
    "orders.last12": "Letzte 12 Monate",
    "orders.count": "{n} Bestellungen",
    "orders.empty": "Keine Bestellungen im gewählten Zeitraum.",
    "orders.col_date": "Datum",
    "orders.col_id": "Bestell-ID",
    "orders.col_recipient": "Empfänger / Stadt",
    "orders.col_status": "Status",
    "orders.col_total": "Gesamt",
    "orders.detail": "Detail",
    "toast.orders_load_error": "Bestellungen können nicht geladen werden",
    "toast.order_detail_error": "Details können nicht geladen werden",
    "mk.assets_title": "Herunterladbare Materialien",
    "mk.all_categories": "Alle Kategorien",
    "mk.empty_category": "Kein Material in dieser Kategorie.",
    "mk.copy_text": "Text kopieren",
    "mk.copied": "Kopiert",
    "mk.download": "Herunterladen",
    "mk.ai_title": "KI-Assistent · Social-Media-Texte",
    "mk.topic": "Thema des Beitrags",
    "mk.topic_ph": "Z. B. Die neue Winterkollektion ist da",
    "mk.product_opt": "Produkt (opt.)",
    "mk.none": "Keins",
    "mk.platform": "Plattform",
    "mk.tone": "Ton",
    "mk.tone_energico": "Energisch",
    "mk.tone_elegante": "Elegant",
    "mk.tone_tecnico": "Technisch",
    "mk.tone_amichevole": "Freundlich",
    "mk.generate": "Beitragstext generieren",
    "mk.generating": "Generierung…",
    "toast.enter_topic": "Geben Sie ein Thema für den Beitrag ein",
    "pf.fiscal_title": "Steuerdaten",
    "pf.fiscal_note": "Offizielle Daten von Brema verwaltet. Für Änderungen kontaktieren Sie Ihren Vertriebspartner.",
    "pf.company": "Firmenname",
    "pf.vat": "USt-IdNr.",
    "pf.billing": "Rechnungsadresse",
    "pf.account_email": "Konto-E-Mail",
    "pf.above59_note": "Steuerdaten und Bestellfreigabe werden direkt von Above 59 S.r.l. (Inhaberin der Marke Brema) geprüft und genehmigt. Wenn Sie offizieller Händler werden, die Gebietsabdeckung prüfen oder Ihr B2B-Konto aktivieren möchten, klicken Sie unten.",
    "pf.contact_us": "Kontakt",
    "pf.write_company": "An das Unternehmen schreiben",
    "pf.subject": "Betreff",
    "pf.subject_ph": "Z. B. Verwaltungsfrage, Rechnung, Retouren, Vorschlag…",
    "pf.contact_title": "Vertriebsabteilung kontaktieren",
    "pf.contact_desc": "Schreiben Sie Ihre Anfrage an Above 59 S.r.l. (Inhaberin der Marke Brema). Wir antworten an die Kontakt-E-Mail Ihres Profils.",
    "pf.message": "Nachricht",
    "pf.contact_ph": "Z. B. Ich möchte mein B2B-Konto aktivieren / die Gebietsexklusivität für meine Stadt prüfen / meine Steuerdaten aktualisieren…",
    "pf.send_request": "Anfrage senden",
    "pf.contacts": "Kontaktdaten",
    "pf.phone": "Telefon",
    "pf.contact_email": "Kontakt-E-Mail",
    "pf.save_contacts": "Speichern",
    "pf.ship_addresses": "Lieferadressen",
    "pf.new_address": "Neue Adresse",
    "pf.no_addresses": "Keine Lieferadresse. Fügen Sie eine hinzu.",
    "pf.default": "Standard",
    "pf.set_default": "Standard",
    "pf.edit_address": "Adresse bearbeiten",
    "pf.address_desc": "Warenzieladresse für Ihre Bestellungen.",
    "pf.save_address": "Adresse speichern",
    "common.cancel": "Abbrechen",
    "common.edit": "Bearbeiten",
    "toast.write_message": "Schreiben Sie eine Nachricht",
    "toast.contact_sent": "Nachricht an die Vertriebsabteilung gesendet. Wir antworten in Kürze.",
    "toast.contact_failed": "Senden fehlgeschlagen",
    "toast.profile_saved": "Profil aktualisiert",
    "toast.save_failed": "Speichern fehlgeschlagen",
    "toast.addr_min": "Geben Sie mindestens Empfänger oder Stadt ein",
    "toast.del_addr_confirm": "Diese Adresse löschen?",
    "toast.order_sent": "Bestellung erfolgreich gesendet",
    "toast.order_confirm_email": "Bestellbestätigung per E-Mail gesendet",
    "login.hero_eyebrow": "AI-Native Plattform",
    "login.hero_title": "KI-gesteuerte Distribution und Marketing technischer Bekleidung.",
    "login.hero_sub": "Autonomer Sales Agent, B2B-Händlerportal und Ambassador-Suche auf einer einzigen Kommandobrücke.",
    "login.tab_login": "Anmelden",
    "login.tab_register": "Geschäft registrieren",
    "login.welcome_back": "Willkommen zurück",
    "login.login_sub": "Zugriff auf Ihren geschützten Bereich.",
    "login.email": "E-Mail",
    "login.password": "Passwort",
    "login.signin": "Anmelden",
    "login.demo": "Demo-Konten",
    "login.demo_admin": "Marke / Admin",
    "login.demo_reseller": "Händler",
    "login.register_title": "Registrieren Sie Ihr Geschäft",
    "login.register_sub": "Erstellen Sie ein B2B-Händlerkonto.",
    "login.ref": "Ansprechpartner",
    "login.city": "Stadt",
    "login.shop": "Firmenname / Geschäftsname",
    "login.vat": "USt-IdNr. / VIES",
    "login.address": "Adresse (Straße und Nr.)",
    "login.zip": "PLZ",
    "login.province": "Provinz",
    "login.country": "Land",
    "login.phone": "Kontakttelefon",
    "login.website": "Website oder Social-Media-Seite (optional)",
    "login.notes": "Zusätzliche Hinweise (optional)",
    "login.forgot": "Passwort vergessen?",
    "login.forgot_title": "Passwort zurücksetzen",
    "login.forgot_desc": "Geben Sie Ihre E-Mail ein: falls registriert, erhalten Sie einen Link zum Zurücksetzen.",
    "login.forgot_send": "Link senden",
    "login.forgot_sent": "Falls die E-Mail registriert ist, erhalten Sie einen Link zum Zurücksetzen.",
    "login.password_ph": "mind. 6 Zeichen",
    "login.create": "Konto erstellen",
    "toast.welcome": "Willkommen, {name}",
    "toast.account_created": "Händlerkonto erstellt",
  },

  es: {
    "lang.label": "Idioma",
    "nav.reseller": "Distribuidor",
    "dash.hello": "Hola, {name}",
    "dash.shop_fallback": "Tu tienda",
    "dash.subtitle": "Gestiona pedidos y materiales de marketing de forma autónoma.",
    "dash.stat_products": "Productos en catálogo",
    "dash.stat_orders": "Mis pedidos",
    "dash.stat_assets": "Materiales de marketing",
    "dash.quick_actions": "Acciones rápidas",
    "dash.quick_order_title": "Pedir del catálogo",
    "dash.quick_order_desc": "Consulta disponibilidad y realiza un nuevo pedido.",
    "dash.quick_mk_title": "Marketing Hub",
    "dash.quick_mk_desc": "Descarga fotos/vídeos y genera textos sociales con IA.",
    "dash.stats_title": "Mis estadísticas",
    "dash.stats_trend": "Evolución de compras",
    "dash.stats_trend_desc": "Gasto mensual (sin IVA) de los últimos 6 meses.",
    "dash.stats_top": "Mis productos más comprados",
    "product.detail_title": "Detalle del producto",
    "product.description_label": "Descripción",
    "product.tech_label": "Características técnicas / Composición",
    "product.colors": "Colores",
    "product.sizes": "Tallas",
    "product.category": "Categoría",
    "product.line_label": "Línea / Colección",
    "product.code": "Código de artículo",
    "product.gender": "Género",
    "product.availability": "Disponibilidad",
    "product.no_description": "No hay descripción disponible.",
    "product.zoom": "Ampliar",
    "product.auto_translated": "Traducción automática",
    "product.translating": "Traduciendo…",
    "product.add_to_order": "Añadir al pedido",
    "nav.dashboard": "Panel",
    "nav.portal": "Portal B2B",
    "nav.logout": "Cerrar sesión",
    "portal.eyebrow": "Portal de Distribuidores B2B",
    "portal.title_fallback": "Portal B2B",
    "portal.subtitle": "Catálogo y disponibilidad, pedidos en autonomía y materiales de marketing.",
    "tier.official": "Distribuidor Oficial",
    "tier.potential": "Distribuidor Potencial · a la espera de activación B2B",
    "tab.catalog": "Catálogo",
    "tab.orders": "Mis Pedidos",
    "tab.marketing": "Centro de Marketing",
    "tab.profile": "Perfil",
    "tab.shipping": "Envíos",
    "tab.sales_conditions": "Condiciones de venta",
    "readonly.badge": "Solo lectura",
    "ship.rules_title": "Reglas de envío",
    "ship.readonly_intro": "Condiciones de envío vigentes, actualizadas por la empresa.",
    "ship.free_threshold": "Umbral de envío gratuito (sin IVA)",
    "ship.flat_cost": "Coste de envío por debajo del umbral (sin IVA)",
    "ship.vat_transport": "IVA sobre el transporte",
    "ship.free": "gratis",
    "ship.note": "Pedidos ≥ {threshold} → {free} · Pedidos < {threshold} → {cost}",
    "sc.title": "Condiciones de venta — descuentos por volumen",
    "sc.readonly_intro": "Descuentos aplicados automáticamente según la zona de destino y el importe imponible del pedido.",
    "sc.col_range": "Base imponible del pedido (sin IVA)",
    "sc.col_discount": "Descuento",
    "sc.over": "Más de {from}",
    "catalog.locked_title": "Cuenta a la espera de activación B2B",
    "catalog.locked_body": "Puedes explorar la colección y descargar catálogos y materiales de marketing. Los precios reservados, el stock y el envío de pedidos estarán disponibles tras la aprobación de Above 59 S.r.l. Solicita la activación en la sección Perfil → Contáctanos.",
    "catalog.empty": "No hay productos en el catálogo. El administrador debe subir el Excel y las fotos.",
    "cart.locked_title": "Pedidos aún no disponibles",
    "cart.locked_body": "El carrito y el envío de pedidos se desbloquean cuando tu cuenta pasa a ser Distribuidor Oficial.",
    "cart.title": "Tu pedido",
    "cart.title_note": "(precios sin IVA)",
    "cart.empty": "Carrito vacío. Añade productos del catálogo.",
    "cart.size": "Talla",
    "cart.ship_address": "Dirección de envío",
    "cart.choose_address": "Elegir dirección",
    "cart.default_suffix": "(predeterminada)",
    "cart.manage_addr_note": "Gestiona las direcciones en la pestaña Perfil.",
    "cart.subtotal": "Base imponible (sin IVA)",
    "cart.list_subtotal": "Subtotal (lista)",
    "cart.volume_discount": "Descuento por volumen",
    "cart.shipping": "Transporte",
    "cart.free_shipping": "Envío Gratuito",
    "cart.shipping_note_below": "Envío gratuito para pedidos netos ≥ {threshold} ({zone}). Añade {missing} para conseguirlo.",
    "cart.shipping_note_free": "Has superado el umbral de {threshold}: envío gratuito ({zone}).",
    "cart.vat": "IVA",
    "cart.vat_exempt": "No sujeto",
    "cart.total_incl": "Total (IVA incl.)",
    "cart.total_exempt": "Total (IVA exento)",
    "cart.submit": "Enviar pedido",
    "toast.select_size": "Selecciona una talla",
    "toast.added": "{item} añadido",
    "product.locked_note": "Precios B2B y disponibilidad reservados a Distribuidores Oficiales.",
    "product.list_public": "Precio público",
    "product.vat_incl": "IVA incl.",
    "product.list_excl": "Tarifa (sin IVA)",
    "product.reseller_discount": "Descuento distribuidor",
    "product.your_price": "Tu precio (sin IVA)",
    "product.pcs_total": "{n} uds. en total",
    "product.only_pcs": "Solo {n} uds.",
    "product.pcs_avail": "{n} disp.",
    "product.size_ph": "Talla",
    "product.size_unica": "Única",
    "product.sold_out": "agotada",
    "product.add": "Añadir",
    "orders.locked_title": "Pedidos aún no disponibles",
    "orders.locked_body": "Podrás enviar pedidos B2B una vez que tu cuenta se active como Distribuidor Oficial. Solicita la activación en Perfil → Contáctanos.",
    "orders.period": "Periodo",
    "orders.from": "Desde",
    "orders.to": "Hasta",
    "orders.apply": "Aplicar",
    "orders.last12": "Últimos 12 meses",
    "orders.count": "{n} pedidos",
    "orders.empty": "No hay pedidos en el periodo seleccionado.",
    "orders.col_date": "Fecha",
    "orders.col_id": "ID Pedido",
    "orders.col_recipient": "Destinatario / Ciudad",
    "orders.col_status": "Estado",
    "orders.col_total": "Total",
    "orders.detail": "Detalle",
    "toast.orders_load_error": "No se pueden cargar los pedidos",
    "toast.order_detail_error": "No se puede cargar el detalle",
    "mk.assets_title": "Materiales descargables",
    "mk.all_categories": "Todas las categorías",
    "mk.empty_category": "No hay material en esta categoría.",
    "mk.copy_text": "Copiar texto",
    "mk.copied": "Copiado",
    "mk.download": "Descargar",
    "mk.ai_title": "Asistente IA · Textos para redes",
    "mk.topic": "Tema del post",
    "mk.topic_ph": "Ej. Ha llegado la nueva colección de invierno",
    "mk.product_opt": "Producto (opc.)",
    "mk.none": "Ninguno",
    "mk.platform": "Plataforma",
    "mk.tone": "Tono",
    "mk.tone_energico": "Enérgico",
    "mk.tone_elegante": "Elegante",
    "mk.tone_tecnico": "Técnico",
    "mk.tone_amichevole": "Amistoso",
    "mk.generate": "Generar texto del post",
    "mk.generating": "Generando…",
    "toast.enter_topic": "Introduce un tema para el post",
    "pf.fiscal_title": "Datos fiscales",
    "pf.fiscal_note": "Datos oficiales gestionados por Brema. Para cambios, contacta con tu comercial.",
    "pf.company": "Razón social",
    "pf.vat": "NIF / IVA",
    "pf.billing": "Dirección de facturación",
    "pf.account_email": "Email de la cuenta",
    "pf.above59_note": "Los datos fiscales y la activación de pedidos son verificados y aprobados directamente por Above 59 S.r.l. (propietaria de la marca Brema). Si deseas ser distribuidor oficial, comprobar la cobertura de zona o activar tu cuenta B2B, haz clic abajo.",
    "pf.contact_us": "Contáctanos",
    "pf.write_company": "Escribir a la empresa",
    "pf.subject": "Asunto",
    "pf.subject_ph": "Ej. Consulta administrativa, factura, devoluciones, propuesta…",
    "pf.contact_title": "Contacta con el departamento comercial",
    "pf.contact_desc": "Escribe tu solicitud a Above 59 S.r.l. (propietaria de la marca Brema). Responderemos al email de contacto de tu perfil.",
    "pf.message": "Mensaje",
    "pf.contact_ph": "Ej. Quiero activar mi cuenta B2B / comprobar la exclusividad de zona para mi ciudad / actualizar mis datos fiscales…",
    "pf.send_request": "Enviar solicitud",
    "pf.contacts": "Datos de contacto",
    "pf.phone": "Teléfono",
    "pf.contact_email": "Email de contacto",
    "pf.save_contacts": "Guardar",
    "pf.ship_addresses": "Direcciones de envío",
    "pf.new_address": "Nueva dirección",
    "pf.no_addresses": "No hay dirección de envío. Añade una.",
    "pf.default": "Predeterminada",
    "pf.set_default": "Predeterminada",
    "pf.edit_address": "Editar dirección",
    "pf.address_desc": "Dirección de destino de la mercancía para tus pedidos.",
    "pf.save_address": "Guardar dirección",
    "common.cancel": "Cancelar",
    "common.edit": "Editar",
    "toast.write_message": "Escribe un mensaje",
    "toast.contact_sent": "Mensaje enviado al departamento comercial. Te responderemos pronto.",
    "toast.contact_failed": "Error al enviar",
    "toast.profile_saved": "Perfil actualizado",
    "toast.save_failed": "Error al guardar",
    "toast.addr_min": "Introduce al menos un destinatario o una ciudad",
    "toast.del_addr_confirm": "¿Eliminar esta dirección?",
    "toast.order_sent": "Pedido enviado correctamente",
    "toast.order_confirm_email": "Confirmación de pedido enviada por email",
    "login.hero_eyebrow": "Plataforma AI-Native",
    "login.hero_title": "Distribución y marketing de ropa técnica, impulsados por la IA.",
    "login.hero_sub": "Sales agent autónomo, portal de distribuidores B2B y búsqueda de embajadores en un único puesto de mando.",
    "login.tab_login": "Acceder",
    "login.tab_register": "Registrar tienda",
    "login.welcome_back": "Bienvenido de nuevo",
    "login.login_sub": "Accede a tu área reservada.",
    "login.email": "Email",
    "login.password": "Contraseña",
    "login.signin": "Acceder",
    "login.demo": "Cuentas demo",
    "login.demo_admin": "Marca / Admin",
    "login.demo_reseller": "Distribuidor",
    "login.register_title": "Registra tu tienda",
    "login.register_sub": "Crea una cuenta de distribuidor B2B.",
    "login.ref": "Persona de contacto",
    "login.city": "Ciudad",
    "login.shop": "Razón social / Nombre de la tienda",
    "login.vat": "NIF/CIF / VIES",
    "login.address": "Dirección (calle y número)",
    "login.zip": "Código postal",
    "login.province": "Provincia",
    "login.country": "País",
    "login.phone": "Teléfono de contacto",
    "login.website": "Sitio web o página social (opcional)",
    "login.notes": "Notas adicionales (opcional)",
    "login.forgot": "¿Contraseña olvidada?",
    "login.forgot_title": "Restablecer la contraseña",
    "login.forgot_desc": "Introduce tu email: si está registrado recibirás un enlace para restablecer la contraseña.",
    "login.forgot_send": "Enviar enlace",
    "login.forgot_sent": "Si el email está registrado, recibirás un enlace para restablecer la contraseña.",
    "login.password_ph": "mín. 6 caracteres",
    "login.create": "Crear cuenta",
    "toast.welcome": "Bienvenido, {name}",
    "toast.account_created": "Cuenta de distribuidor creada",
  },
};

export function detectLang() {
  try {
    const saved = localStorage.getItem("brema_lang");
    if (saved && TR[saved]) return saved;
  } catch (e) { /* ignore */ }
  const nav = (navigator.language || navigator.userLanguage || "en").slice(0, 2).toLowerCase();
  return TR[nav] ? nav : "en";
}

const I18nContext = createContext({ lang: "it", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang());
  useEffect(() => { try { document.documentElement.lang = lang; } catch (e) {} }, [lang]);
  const setLang = (l) => {
    if (!TR[l]) return;
    try { localStorage.setItem("brema_lang", l); } catch (e) {}
    setLangState(l);
  };
  const t = (key, vars) => {
    let s = (TR[lang] && TR[lang][key]) || TR.en[key] || TR.it[key] || key;
    if (vars) for (const k in vars) s = s.replace(new RegExp("\\{" + k + "\\}", "g"), vars[k]);
    return s;
  };
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
